const siteSearch = document.querySelector('.site-search')
const trigger = document.querySelector('[data-search-trigger]')
const input = document.querySelector('.site-search__input')

if (trigger) {
  trigger.addEventListener('click', function (e) {
    siteSearch.classList.toggle('is-open')
    input.focus()

    const openedMegaMenu = document.querySelector('.mega-menu.is-open')

    if (openedMegaMenu) {
      openedMegaMenu.classList.remove('is-open')
    }
  })
}